import { YOO_FINDS_CDN } from "@/common";

const ROOT = `${YOO_FINDS_CDN}/h5/about`;
export const ABOUT_YLOGO = `${ROOT}/Ylogo.png`;
export const ABOUT_BRIGHT__SPOT = [
  {
    icon: `${ROOT}/brightspot-1.png?imageMogr2/thumbnail/!80p/format/webp`,
    num: "350k+",
    content: "Active Creator Database",
  },
  {
    icon: `${ROOT}/brightspot-2.png?imageMogr2/thumbnail/!80p/format/webp`,
    num: "20k+",
    content: "Creators Selecting Products Daily",
  },
  {
    icon: `${ROOT}/brightspot-3.png?imageMogr2/thumbnail/!80p/format/webp`,
    num: "85%",
    content: "Higher Commission",
  },
  {
    icon: `${ROOT}/brightspot-4.png?imageMogr2/thumbnail/!80p/format/webp`,
    num: "3000+",
    content: "Brand Partnerships",
  },
];

export const ABOUT_PAST_EVENT = [
  {
    id: 6,
    date: "Oct 15-16, 2025 (2 days)",
    address: "",
    content:
      "YFCon- BFCM&Xmas Edition Creator x Seller Matchingmaking Event LA, 10000 attendees",
    imgSrc: `${ROOT}/about6-v3.png?imageMogr2/thumbnail/!80p/format/webp`,
    activityUrl: "",
  },
  {
    id: 5,
    date: "Jun.11.2025",
    address: "Los Angeles",
    content: "Creator Picks Event, in collaboration with TikTok Shop",
    imgSrc: `${ROOT}/about1.png`,
    activityUrl: "",
  },
  {
    id: 4,
    date: "Apr.30.2025",
    address: "Dallas",
    content: "Creator Picks Product Selection Event",
    imgSrc: `${ROOT}/about2.png`,
    activityUrl: "",
  },
  {
    id: 3,
    date: "‌Mar.‌12.2025",
    address: "New York",
    content: "Creator Picks Product Selection Event",
    imgSrc: `${ROOT}/about3.png`,
    activityUrl: "",
  },
  {
    id: 2,
    date: "‌Jan.‌11.2025",
    address: "Shenzhen",
    content:
      "YooFinds and FastMoss hosted the third FGVCOn conference, with 20,000 attendees",
    imgSrc: `${ROOT}/about4.png`,
    activityUrl: "",
  },
  {
    id: 1,
    date: "Oct.01. 2025",
    address: "Los Angeles",
    content: "Product Selection Event Hosted by YooFinds & FastMoss",
    imgSrc: `${ROOT}/about5.png`,
    activityUrl: "",
  },
];
